export default __webpack_public_path__ + "static/media/shutterstock_587513495.ddd627b5.png";